import {
  call, put, takeEvery,
} from 'redux-saga/effects';
import {
  fetchDatasetMetricsError,
  fetchDatasetMetricsSuccess,
} from '../actions';
import actions from '../constants';
import DatasetMetricsService from '../service';

const callAdapter = (promise) => promise.then((response) => ({ response })).catch((error) => ({ error }));

const callFetchDatasetMetrics = (code) => callAdapter(
  DatasetMetricsService.metrics(code),
);

export function* metrics({ category, code }) {
  const { response, error } = yield call(callFetchDatasetMetrics, code);
  if (error) {
    yield put(fetchDatasetMetricsError(category, code, error));

    return;
  }

  yield put(
    fetchDatasetMetricsSuccess(category, code, response),
  );
}

export default function* datasetMetricsApi() {
  yield takeEvery(actions.FETCH_DATASET_METRICS, metrics);
}
